<template src='./treeGrid.pug' lang='pug'></template>

<script>
import moment from 'moment'
import MassTaskModal from '../modals/massTaskModal/MassTaskModal'
import MassDeclassifyModal from '../modals/massDeclassifyModal/MassDeclassifyModal'
import ButtonPrimary from '../buttons/buttonPrimary/ButtonPrimary'
import language from '../../../build/language'

const formatter = new Intl.NumberFormat(language.getDatePickerLanguage()).format

export default {
  name: 'TreeGrid',

  components: {
    MassTaskModal,
    ButtonPrimary,
    MassDeclassifyModal
  },

  props: {
    gridId: {
      type: String
    },
    result: {
      type: Object,
      required: true
    },
    exportUrl: {
      type: String,
      required: true
    },
    treeGridFileName: {
      type: String,
      required: true
    },
    treeGridLayoutPath: {
      type: String
    },
    cfgObj: {
      type: Object,
      required: false
    },
    showExportButton: {
      type: Boolean,
      default: true
    },
    showMassTaskAction: {
      type: Boolean,
      default: false
    },
    showAnnulledMovementButton: {
      type: Boolean,
      default: false
    },
    showExcluirRemessaButton: {
      type: Boolean,
      default: false
    },
    showHrTopGrid: {
      type: Boolean,
      default: true
    },
    showAlert: {
      type: Boolean,
      default: false
    },
    showMassDeclassifyAction: {
      type: Boolean,
      default: false
    },
    alertMessage: {
      type: String,
      required: false
    },
    treeGridModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      lancamentosSelecionados: {
        arrayIdExtBancSelecionado: [],
        arrayIdMovFinSelecionado: [],
        arrayLinhaSelecionada: []
      }
    }
  },

  computed: {
    allowMassTask () {
      // 209 é o código para funcionalidade de criação de tarefas
      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(209) >= 0
    },

    showMassTaskButton () {
      return this.showMassTaskAction && this.allowMassTask
    },

    showMassDeclassifyButton () {
      return this.showMassDeclassifyAction
    },

    treeGridResult () {
      return this.result
    },

    btnId () {
      return `btnExportarXls-${this.gridId}`
    },

    btnTarefaEmMassaId () {
      return `btnIniciarTarefaEmMAssa-${this.gridId}`
    },

    modalTarefaEmMassaId () {
      return `modalIniciarTarefaEmMAssa-${this.gridId}`
    },

    btnDesclassificarEmMassaId () {
      return `btnIniciarDesclassificarEmMassa-${this.gridId}`
    },

    modalDesclassificarEmMassaId () {
      return `modalIniciarDesclassificarEmMassa-${this.gridId}`
    },

    btnAnulacaoContaLancamentoId () {
      return `btnIniciarAnulacaoContaLancamento-${this.gridId}`
    },

    btnExcluir () {
      return `btnExcluirRemessas-${this.gridId}`
    },

    gridItemId () {
      switch (this.gridId) {
        case 'ExtratoConta':
          return 'IdLancamento'
        case 'RelatorioConciliacao':
          return 'IdConciliacaoLote'
        case 'MovimentoFinanceiro':
          return 'IdMovimentacao'
        case 'RemessasIntegracao':
          return 'IdMov'
      }
    },

    labelBtnAnulacaoContaLancamento () {
      return this.gridId === 'LancamentoDuplicado' ? this.$t('analiseDuplicidade.labels.anularLancamento') : this.$t('analiseDuplicidade.labels.reverterAnulacao')
    }
  },

  watch: {
    treeGridResult () {
      this.createTreeGrid()
    }
  },

  methods: {
    exportarXls () {
      window.Grids[0].Source.Export.Type = ''
      window.Grids[0].ActionExport()
    },

    createTreeGrid () {
      let treegridCfg = {
        Text: {
          Url: '../assets/grid/Text-' + language.getCookieByName('language') + '.xml'
        },
        Layout: {
          Url: '../assets/treegridLayouts/' + this.treeGridLayoutPath + '/config-' + language.getCookieByName('language') + '.js'
        },
        Data: {
          Data: this.result
        },
        Export: {
          Url: this.exportUrl + '?treeGridFileName=' + this.treeGridFileName
        }
      }
      if (this.cfgObj) {
        treegridCfg.Layout = {}
        treegridCfg.Layout.Data = this.cfgObj
      }
      window.TreeGrid(treegridCfg, this.gridId)
      window.Grids.OnClickButtonExport = function (G) {
        window.Grids[0].Source.Export.Type = ''
        window.Grids[0].ActionExport()
        return true
      }
      // Correção no momento da exportação para campos do tipo data
      window.Grids.OnGetExportValue = function (G, row, col, str) {
        if (G.ExportFormat === 'csv') {
          if (G.GetType(row, col) === 'Date') {
            if (window.Get(row, col)) {
              return moment(window.Get(row, col)).utc().format('L')
            }
          } else {
            return window.Get(row, col, str)
          }
        } else if (G.ExportFormat === 'xlsx') {
          if (typeof str === 'number' && /^id/i.test(col)) {
            return str.toString().length >= 15 ? 'ㅤ' + formatter(str) : formatter(str)
          }
        } else if (G.ExportFormat === 'xls') {
          if (typeof str === 'number' && /^id/i.test(col)) {
            return str.toString().length >= 15 ? 'ㅤ' + formatter(str) : formatter(str)
          }
        }
      }
    },

    openModalMassTask () {
      this.lancamentosSelecionados = {
        arrayIdExtBancSelecionado: [],
        arrayIdMovBancSelecionado: [],
        arrayIdMovFinSelecionado: [],
        arrayLinhaSelecionada: []
      }

      // Percorre a grid verificando os checks selecionados
      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {
        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {
          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {
            // desabilitando a criacao de watchers pelo Vue para evitar estouro de pilha do navegador
            linha._isVue = true
            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados)
            // habilitando novamente apos a recursao
            linha._isVue = false
          }
        }
      }
      $('#' + this.modalTarefaEmMassaId).modal({ backdrop: 'static', keyboard: false })
    },

    openModalMassDeclassify () {
      this.lancamentosSelecionados = {
        arrayIdExtBancSelecionado: [],
        arrayIdMovBancSelecionado: [],
        arrayIdMovFinSelecionado: [],
        arrayLinhaSelecionada: []
      }

      // Percorre a grid verificando os checks selecionados
      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {
        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {
          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {
            // desabilitando a criacao de watchers pelo Vue para evitar estouro de pilha do navegador
            linha._isVue = true
            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados)
            // habilitando novamente apos a recursao
            linha._isVue = false
          }
        }
      }
      $('#' + this.modalDesclassificarEmMassaId).modal({ backdrop: 'static', keyboard: false })
    },

    annulMovements () {
      this.lancamentosSelecionados = {
        arrayIdExtBancSelecionado: [],
        arrayLinhaSelecionada: []
      }

      // Percorre a grid verificando os checks selecionados
      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {
        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {
          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {
            // desabilitando a criacao de watchers pelo Vue para evitar estouro de pilha do navegador
            linha._isVue = true
            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados)
            // habilitando novamente apos a recursao
            linha._isVue = false
          }
        }
      }
      this.$emit('annulMovements', {
        idsContaLancamento: this.lancamentosSelecionados.arrayIdExtBancSelecionado,
        flAnulado: this.gridId === 'LancamentoDuplicado' ? 1 : 0,
        flRevertido: this.gridId === 'LancamentoDuplicado' ? 0 : 1
      })
    },

    excluirRemessas () {
      this.lancamentosSelecionados = {
        arrayIdRemessaIntegracao: [],
        arrayLinhaSelecionada: []
      }

      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {
        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {
          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {
            // desabilitando a criacao de watchers pelo Vue para evitar estouro de pilha do navegador
            linha._isVue = true
            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados)
            // habilitando novamente apos a recursao
            linha._isVue = false
          }
        }
      }
      this.$emit('remittanceRemoval', this.lancamentosSelecionados)
    },

    // Dado uma linha da grid, percorre todas as linhas filhas e retorna um array contendo o id das vendas selecionadas
    salvaVendasSolicitadas (linha, lancamentosSelecionados) {
      // se a linha possuir filho, ou seja, for um grupo.
      if (linha.firstChild) {
        for (var linhaFilha = linha.firstChild; linhaFilha; linhaFilha = linhaFilha.nextSibling) {
          lancamentosSelecionados = this.salvaVendasSolicitadas(linhaFilha, lancamentosSelecionados)
        }
      } else if (linha.Kind === 'Data' && linha['Check'] && linha['Check'] === 1) {
        // se a linha estiver com o check selecionado
        if (this.gridId === 'ExtratoConta') {
          lancamentosSelecionados.arrayIdExtBancSelecionado.push(linha[this.gridItemId])
          if (linha['SituacaoConcil'] === 'A') {
            lancamentosSelecionados.arrayIdMovBancSelecionado.push(linha[this.gridItemId])
          }
        } else if (this.gridId === 'MovimentoFinanceiro') {
          lancamentosSelecionados.arrayIdMovFinSelecionado.push(linha[this.gridItemId])
        } else if (this.gridId === 'RemessasIntegracao') {
          lancamentosSelecionados.arrayIdRemessaIntegracao.push(linha[this.gridItemId])
        } else {
          linha['IdContaLancamento']
          ? lancamentosSelecionados.arrayIdExtBancSelecionado.push(linha['IdContaLancamento'])
          : lancamentosSelecionados.arrayIdMovFinSelecionado.push(linha['IdMovFinanceiro'])
        }
        lancamentosSelecionados.arrayLinhaSelecionada.push(linha)
      }
      return lancamentosSelecionados
    }
  },

  destroyed () {
    if (!this.treeGridModal) {
      window.DisposeGrids()
    } else if (this.cfgObj && this.cfgObj.Cfg && this.cfgObj.Cfg.id) {
      window.Grids[this.cfgObj.Cfg.id].Dispose()
    }
  }
}
</script>

<style lang='css'>
.alertGrid {
  font-style: italic;
  font-size: 12px;
  color: #666;
  padding-top: 20px;
}
#botoesExportacoes {
  padding-top: 15px;
  padding-bottom: 15px;
}

#TreeGrid {
  min-width: 100%;
  min-height: 500px;
}

.treeGridModal {
  min-height: 50vh;
  max-width: 100%;
}

.treeGridCols {
  padding-left: 0;
  padding-right: 0;
}

td.GOCellSpaceEdit.GOText {
  min-width: 50px !important;
}

.COMain {
  font-family: 'Inter', sans-serif;
}

/*Tabs topo*/

.COTabHtml,
.COTabHtml1,
COTabHtmlIcon1 {
  font-size: 13px;
  font-family: 'Inter', sans-serif;
font-weight: 500;
  white-space: nowrap;
  text-align: center;
  padding: 9px 8px 7px 8px!important;
  border-left: none;
  background: #DEEAF0;
  color: #092446;
  /*border:1px solid #999;*/
  border-bottom: none;
  border-top: 3px solid #FAFAFA;
}

.COTabHtml1 {
  background: #092446!important;
  border-top: 3px solid #31C1DA;
  /*border: 1px solid #005e78;*/
  border-bottom: none;
  color: #FFF;
}

.COTabHtml1:hover {
  background: #092446!important;
  /*border: 1px solid #005e78;*/
  border-bottom: none;
  color: #FFF;
}

.COTabHtml:hover {
  background: #bbd3df!important;
  /*border: 1px solid #005e78;*/
  border-bottom: 1px solid #005e78;
  border-bottom: none;
  color: #092446;
}

.CORowAbove,
.CORowBelow {
  margin-left: 1px;
}

/*Cabeçalho*/

.COCellHeader {
  background: #1C3B60;
}

.COBig .CORowSpaceFirst .COSolidRow {
  padding-top: 0px
}

.COHeadLeft,
.COHeadMid,
.COHeadRight {
  margin-top: -0.02px;
}

.COPickMY {
  background: #1C3B60;
}

/*Botões*/

u.COToolSpaceButton,
.COMain .COToolSpaceIconInner {
  padding: 4px 0px 4px 0px;
  min-width: 60px !important;
  text-align: center;
  background: #EEE;
  border: 1px solid #CCC;
  color: #666;
}

u.COToolSpaceButton:hover {
  background: #F1F1F1;
  color: #000;
  font-weight: normal;
}

u.COToolButtonButton1,
u.COToolSpaceButton1,
u.COToolButtonButton1:active,
u.COToolSpaceButton1:active {
  background: #1C3B60;
  color: #FFF;
  font-weight: bold;
  min-width: 60px;
  padding-right: 0px;
  padding-left: 0px;
}

/*Barra de agrupamento*/

.COHeaderGroupCustom {
  font-size: 13px;
  font-family: 'Inter', sans-serif;
  color: #96ACC5;
  padding-left: 10px;
  cursor: default;
  white-space: nowrap;
  font-style: italic;
  background-color: #FFF;
}

.COHeaderGroup {
  border: 1px solid #96ACC5 !important;
  border-left: none;
  font-family: 'Inter', sans-serif;
  background-color: #D2DEEC;
  cursor: move;
}

.COHeaderGroup>div {
  font-weight: normal;
}

/*Barra de busca*/

.COMain i {
  color: #96ACC5;
}

/*Conteúdo das tabelas*/

.COClassReadOnly {
  color: #333;
}

.COHoverRowBackground {
  opacity: 0.3;
  filter: alpha(opacity=30);
  background: #AAA;
}

.COFocusRowBackground {
  opacity: 0.3;
  filter: alpha(opacity=30);
  background: #AAA;
}

/*Cor de fundo das linhas selecionadas com o radio button*/

.COClassSelected {
  background-color: #DEEAF0
}

/*Cor alternada do fundo*/

.COColorAlternate {
  background-color: #CCC;
}

/*Cor de fundo das linhas ao se marcar a linha*/

.COColorFound1 {
  background-color: #FFDFBF;
}

.COColorFound2 {
  background-color: #F7D9FF;
}

.COColorFound3 {
  background-color: #D1FFDB;
}

.COToolbarRow tr td:last-child {
  display: none;
}

.COToolHtml1,
.COToolHtmlIcon1 {
  color: #40b9bb;
}

/*Caixa de configurações da grid*/

.COMenuHead {
  color: white;
  background: #1C3B60
}

.CODialogButton {
  background: #EEE;
  border: 1px solid #EEE;
  color: #666;
}

.CODialogButton:hover {
  background: #F1F1F1;
  border: 1px solid #F1F1F1;
  color: #000;
}

.CODialogButton:active {
  background: #1C3B60;
  color: #FFF;
  font-weight: bold;
}

.CODialogButton:active {
  background: #1C3B60;
  color: #FFF;
  font-weight: bold;
}

.COChildPart {
  border-bottom: 1px solid #DDD;
}

.COSection, .COSectionFF3 {
  contain: none;
}

#TreeGridWrapper table > tbody > tr, th, td {
  vertical-align: top !important;
}

/* alteracoes da versao 14.1.3 */

.COCellSpace, .COCellSpaceIcon, .COCellSpaceButton, .COCellSpaceButtonIcon, .COCellSpaceButtonButton, .COCellSpacePanel,
.COCellSpaceBool, .COCellSpaceRadio, .COCellSpaceSelect, .COCellSpaceEdit {
  border-left: none;
  border-right: none;
}

.COMenuBody { margin: 0 !important; width: auto !important; border: none !important; }

.COCfgMenuOuter, .COColumnsMenuOuter { padding: 0 !important; }

.COCfgMenuHead, .COColumnsMenuHead { border-color: #1c3b60 !important; }

.COMenuFoot { border: none !important; }

.CORowSpace0 .COSolidRow, .CORowSpace1 .COSolidRow, .CORowSpace2 .COSolidRow, .CORowSpace3 .COSolidRow {
  margin: 0 !important;
}

u.COToolButtonButton1, u.COToolSpaceButton1, u.COToolButtonButton1:active, u.COToolSpaceButton1:active {
  min-width: 60px !important;
}

.COMenuCursorIcon { background: none !important; }

.COGroupRow, .COSearchRow, .COPagerRow, .COToolbar1Row, .COToolbar2Row, .COToolbar3Row,
.COTopbarRow, .COTopbar1Row, .COTopbar2Row, .COTopbar3Row, .COTabberRow {
  border-top: none !important;
  border-bottom: none !important;
}

.COHeadMid, .COBodyMid, .COFootMid { border-left: none !important; }

.COHoverRowBackground { opacity:0.1; filter:alpha(opacity=10); background:#888; }
.COHoverRowBorder { padding: 0 !important; }
.COHoverCellBorder { padding: 0 !important; border: 0 !important; }

.COFocusRowBackground { background: transparent !important; }
.COFocusCellBorder { padding: 0 !important; border: 0 !important; }
.COFocusCellSpaceBorder { border: none !important; }
.COFocusCellCorner { background: transparent !important; }

.COColorSelected,.COColorSelectedCell { background-color:#FFFFA6 !important }

.COColorNoFocus { background-color: #fff; }
.COColorReadOnly { background-color: #fff; }

.CODropCols { padding: 0 2px 0 2px !important; }

.COTreeImageIE { padding-bottom: 15px !important; display: inline !important; }

.COCellSpace, .COCellSpaceIcon, .COCellSpaceButton, .COCellSpaceButtonIcon, .COCellSpaceButtonButton, .COCellSpacePanel,
.COCellSpaceBool, .COCellSpaceRadio, .COCellSpaceSelect, .COCellSpaceEdit {
  vertical-align: middle !important;
}

.COMainTable { border: 0 !important; }

.COHeaderGroupCustom { border: 1px solid #cdd8e4; }

.COMenuCursorIcon { background: none !important; }
.COMenuHoverIcon { background: none !important; }

.COMenuBody { padding: 0 !important; }

.alertGrid { font-family: 'Inter', serif; }

.COTreeImageIE { padding-bottom: auto !important; } /* Corrige um bug no Chrome */

.COOverflowDisable { background-color: transparent !important; }

.COEditCellBorder{ border: none !important; }

.COEditCellInput { background-color: inherit !important; }

.COEditCellSpaceBorder { border: none !important; }

.COFocusRowBackground { opacity: 0.3 !important; background-color: #AAA !important; }

.TSTree {
  overflow: visible !important;
}

.COPageFirst { border-top: 1px solid #DDD; }

td.COCellBase.COType.COHtml.COCell.CONoLeft {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// TreeGrid.vue?78ed4ab4